var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "spinner-border",
      class: _vm.cls,
      attrs: { role: "status" }
    },
    [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }